export default __webpack_public_path__ + "static/media/InsideBrain_05.6ad8ed27.png";